import { Component, OnInit, AfterViewInit } from "@angular/core";
import { SchoolService } from "../../../shared/services/school.service";
import { ReportService } from "../report.service";
import { Subscription } from "rxjs";
import { UserService } from "../../../shared/services/user.service";
import { HttpclientService } from "../../../shared/services/httpclient.service";
import { PersonSelectorService } from "../../personselector/personselector.service";
import { Router } from "@angular/router";
import { DialogService } from "primeng/dynamicdialog";

@Component({
	templateUrl: "./studentwithalert.component.html",
})
export class StudentWithAlertComponent implements OnInit {
	constructor(
		private schoolService: SchoolService,
		private reportService: ReportService,
		private studentService: PersonSelectorService,
		private userService: UserService,
		private dialogService: DialogService
	) {}

	report = {
		SchoolID: 0,
		InfractionID: 0,
		PenaltyID: 0,
		Criteria: "",
	};
	schoolList: any = [];
	infractionList: any = [];
	actionList: any = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	user: any;
	selectedStudent: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ngOnInit() {
		this.loadSchoolist();
	}
	private loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All schools",
					});
				} else {
					this.report.SchoolID = this.schoolList[0].SchoolID;
				}
				this.InfractionList();
				this.PenaltyList();
			},
			(error) => {}
		);
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.InfractionList();
		this.PenaltyList();
	}

	private InfractionList() {
		this.report.InfractionID = 0;
		var result = this.reportService.InfractionGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.infractionList = response;

				if (this.infractionList.length > 1) {
					this.infractionList.unshift({
						InfractionID: 0,
						InfractionDesc: "All Infractions",
					});
				} else {
					this.report.InfractionID = this.infractionList[0].InfractionID;
				}
			},
			(error) => {}
		);
	}

	private PenaltyList() {
		this.report.InfractionID = 0;
		var result = this.reportService.PenaltyGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.actionList = response;

				if (this.actionList.length > 1) {
					this.actionList.unshift({
						PenaltyID: 0,
						PenaltyDesc: "All Actions",
					});
				} else {
					this.report.PenaltyID = this.actionList[0].PenaltyID;
				}
			},
			(error) => {}
		);
	}
}
